import { render } from "./LogoTitle.vue?vue&type=template&id=9c7b5efa"
import script from "./LogoTitle.vue?vue&type=script&lang=js"
export * from "./LogoTitle.vue?vue&type=script&lang=js"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__